import breakPoints from "helpers/Styles";
import Image from "next/image";
import PropTypes from "prop-types";

const ImageWithTitle = ({ block, primaryFontColor }) => {
  if (!block) return "";
  const { primary } = block;
  const title = primary?.title1;
  const imageUrl = primary?.image?.url;
  const imageMobile = primary?.image_mobile?.url;
  const titleColour = primary?.title_colour ? primary.title_colour : primaryFontColor;
  return (
    <>
      <div className="image_with_title wrapper">
        <div className="image_desktop">
          <Image draggable={false}
            src={imageUrl}
            alt="Picture of block"
            width={1920}
            height={780}
          />
        </div>

        <div className="image_mobile">
          <Image draggable={false}
            src={imageMobile}
            alt="Picture of block"
            width={primary?.image_mobile?.dimensions?.width || 780}
            height={primary?.image_mobile?.dimensions?.height || 780}
          />
        </div>

        <div className="contents">
          {title && <div className="title">{title}</div>}
        </div>
      </div>
      <style jsx>
        {`
          .image_with_title {
            position: relative;
            background-color: inherit;
          }
          .contents {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
          .title {
            position: absolute;
            top: 45%;
            color: ${titleColour};
            font-family: 'big_noodle_titling';
            font-size: 39px;
            letter-spacing: 0;
            line-height: 48px;
          }
          .image_mobile {
            display: none;
          }

          @media (max-width: ${breakPoints.medium}) {
            .title {
              font-size: 26px;
              top: 33%;
            }
          }
          @media (max-width: 450px) {
            .title {
              font-size: 26px;
              top: 33%;
            }
            .image_desktop {
              display: none;
            }
            .image_mobile {
              display: block;
            }
        `}
      </style>
    </>
  );
};
ImageWithTitle.propTypes = {
  block: PropTypes.shape({
    primary: PropTypes.shape({
      title1: PropTypes.string,
      image: PropTypes.object,
      image_mobile: PropTypes.object,
    }),
  }),
};

ImageWithTitle.defaultProps = {
  block: null,
};

export default ImageWithTitle;
